import { render, staticRenderFns } from "./defaultEntry.vue?vue&type=template&id=af360be2&scoped=true"
import script from "./defaultEntry.vue?vue&type=script&lang=js"
export * from "./defaultEntry.vue?vue&type=script&lang=js"
import style0 from "./defaultEntry.vue?vue&type=style&index=0&id=af360be2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af360be2",
  null
  
)

export default component.exports